export default __webpack_public_path__ + "static/media/044-koala.891f6393.svg";